export const TAU = Math.PI * 2;

export const randomAngle = () => Math.random() * TAU;

export const clampAngle = (angle) => {
  let result = angle;
  while (result < 0) result += TAU;
  while (result >= TAU) result -= TAU;
  return result;
};

export const getLocalAngle = (angle, startAngle) => clampAngle(angle - startAngle);

export const wedgePolarToCanvas = (geometry, r, t) => {
  const angle = geometry.startAngle + geometry.wedgeAngle * t;
  const radius = geometry.radius * r;
  return {
    x: geometry.centerX + Math.cos(angle) * radius,
    y: geometry.centerY + Math.sin(angle) * radius,
  };
};

export const transformPointForSector = (geometry, point, localAngle, mirror, sectorIndex) => {
  const baseAngle = geometry.startAngle + geometry.wedgeAngle * sectorIndex;
  const angle = mirror ? baseAngle + (geometry.wedgeAngle - localAngle) : baseAngle + localAngle;
  return {
    x: geometry.centerX + Math.cos(angle) * point.radius,
    y: geometry.centerY + Math.sin(angle) * point.radius,
  };
};